import useUsersProviders from '@hooks/query/provider/useUsersProviders';
import { PlusOutlined } from '@icon';
import { Button, Table } from '@ui';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTableColumns } from './profile-providers.utils';

const ProfileProviders: React.FunctionComponent = () => {
  const { push } = useHistory();
  const { data, isFetching } = useUsersProviders();
  const columns = useTableColumns();

  return (
    <>
      <Table.Header
        title="Zoznam poskytovateľov"
        // extra={
        //   <Button
        //     size="medium"
        //     Icon={PlusOutlined}
        //     onClick={() => push('/business/create-provider')}
        //   >
        //     Vytvoriť poskytovateľa
        //   </Button>
        // }
      />
      <Table
        columns={columns}
        data={data ?? []}
        showEmpty
        emptyTitle="Žiadny poskytovatelia"
        loading={isFetching}
      />
    </>
  );
};

export default React.memo(ProfileProviders);
